import { alpha } from '@mui/material';
import { GREY, BASE_COLORS } from './palette.base';

/* ---------- base shadows (array) ---------- */

const createShadows = color => {
  const t1 = alpha(color, 0.2);
  const t2 = alpha(color, 0.14);
  const t3 = alpha(color, 0.12);

  return [
    'none',
    `0px 2px 1px -1px ${t1},0px 1px 1px 0px ${t2},0px 1px 3px 0px ${t3}`,
    `0px 3px 1px -2px ${t1},0px 2px 2px 0px ${t2},0px 1px 5px 0px ${t3}`,
    `0px 3px 3px -2px ${t1},0px 3px 4px 0px ${t2},0px 1px 8px 0px ${t3}`,
    `0px 2px 4px -1px ${t1},0px 4px 5px 0px ${t2},0px 1px 10px 0px ${t3}`,
    `0px 3px 5px -1px ${t1},0px 5px 8px 0px ${t2},0px 1px 14px 0px ${t3}`,
    `0px 3px 5px -1px ${t1},0px 6px 10px 0px ${t2},0px 1px 18px 0px ${t3}`,
    `0px 4px 5px -2px ${t1},0px 7px 10px 1px ${t2},0px 2px 16px 1px ${t3}`,
    `0px 5px 5px -3px ${t1},0px 8px 10px 1px ${t2},0px 3px 14px 2px ${t3}`,
    `0px 5px 6px -3px ${t1},0px 9px 12px 1px ${t2},0px 3px 16px 2px ${t3}`,
    `0px 6px 6px -3px ${t1},0px 10px 14px 1px ${t2},0px 4px 18px 3px ${t3}`,
    `0px 6px 7px -4px ${t1},0px 11px 15px 1px ${t2},0px 4px 20px 3px ${t3}`,
    `0px 7px 8px -4px ${t1},0px 12px 17px 2px ${t2},0px 5px 22px 4px ${t3}`,
    `0px 7px 8px -4px ${t1},0px 13px 19px 2px ${t2},0px 5px 24px 4px ${t3}`,
    `0px 7px 9px -4px ${t1},0px 14px 21px 2px ${t2},0px 5px 26px 4px ${t3}`,
    `0px 8px 9px -5px ${t1},0px 15px 22px 2px ${t2},0px 6px 28px 5px ${t3}`,
    `0px 8px 10px -5px ${t1},0px 16px 24px 2px ${t2},0px 6px 30px 5px ${t3}`,
    `0px 8px 11px -5px ${t1},0px 17px 26px 2px ${t2},0px 6px 32px 5px ${t3}`,
    `0px 9px 11px -5px ${t1},0px 18px 28px 2px ${t2},0px 7px 34px 6px ${t3}`,
    `0px 9px 12px -6px ${t1},0px 19px 29px 2px ${t2},0px 7px 36px 6px ${t3}`,
    `0px 10px 13px -6px ${t1},0px 20px 31px 3px ${t2},0px 8px 38px 7px ${t3}`,
    `0px 10px 13px -6px ${t1},0px 21px 33px 3px ${t2},0px 8px 40px 7px ${t3}`,
    `0px 10px 14px -6px ${t1},0px 22px 35px 3px ${t2},0px 8px 42px 7px ${t3}`,
    `0px 11px 14px -7px ${t1},0px 23px 36px 3px ${t2},0px 9px 44px 8px ${t3}`,
    `0px 11px 15px -7px ${t1},0px 24px 38px 3px ${t2},0px 9px 46px 8px ${t3}`,
  ];
};

/* ---------- custom shadows (object) ---------- */

const createCustomShadows = color => {
  const t = alpha(color, 0.24);

  return {
    z1: `0 1px 2px 0 ${t}`,
    z8: `0 8px 16px 0 ${t}`,
    z12: `0 0 2px 0 ${t}, 0 12px 24px 0 ${t}`,
    z16: `0 0 2px 0 ${t}, 0 16px 32px -4px ${t}`,
    z20: `0 0 2px 0 ${t}, 0 20px 40px -4px ${t}`,
    z24: `0 0 4px 0 ${t}, 0 24px 48px 0 ${t}`,
    primary: `0 8px 16px 0 ${alpha(BASE_COLORS.primary.main, 0.24)}`,
    secondary: `0 8px 16px 0 ${alpha(BASE_COLORS.secondary.main, 0.24)}`,
    info: `0 8px 16px 0 ${alpha(BASE_COLORS.info.main, 0.24)}`,
    success: `0 8px 16px 0 ${alpha(BASE_COLORS.success.main, 0.24)}`,
    warning: `0 8px 16px 0 ${alpha(BASE_COLORS.warning.main, 0.24)}`,
    error: `0 8px 16px 0 ${alpha(BASE_COLORS.error.main, 0.24)}`,
  };
};

/* ---------- factory ---------- */

export function shadowsFactory(mode = 'light') {
  const baseColor = mode === 'light' ? GREY[500] : GREY[800];

  return {
    shadows: createShadows(baseColor),
    customShadows: createCustomShadows(baseColor),
  };
}
